import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Coupon } from '@accounting/interfaces/coupon';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider.vue';

@Component({
  name: 'bpc-coupon-input',
  components: {
    'bpc-std-form': StdForm,
  },
})
export default class CouponInput extends Vue {
  $refs: {
    stdForm: InstanceType<typeof StdForm> & {
      saveEntity(): void;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: EntityFormProvider;
    };
  };

  @Prop([String, Number]) readonly entityId: string | number;
  @Prop({ type: String, default: 'apply-coupon' }) formConfigName: string;

  get applyCouponPath() {
    return `${this.$bpcApiRouteHelper.getEntityPath('coupon')}/apply`;
  }

  public entity: string = 'coupon';
  public permissionEntityNameToUse: string = 'coupons';
  public formModel: Coupon = null;
  public showCouponForm: boolean = false;

  public couponCode: string = null;

  public applyCoupon() {
    const tenant = this.$store.getters['tenant/selectedTenantId'];
    const contactId = this.$store.getters['auth/contactId']({ tenantId: tenant });
    this.$set(this.$refs.stdForm.formModel, 'contact_id', contactId);
    this.$refs.stdForm.saveEntity();
  }

  public onFormSaved(event) {
    this.$store.dispatch(`shoppingCart/setOrdersToCheckout`, { ordersToCheckout: event.data });
    this.$root.$emit('refresh-orders');
    this.$emit('coupon-added');
  }

  toggleCouponForm() {
    this.showCouponForm = !this.showCouponForm;
  }
}
